import { CONSENT_ADVERTISING, CONSENT_ANALYTICS } from "../events";
import { injectScript } from "./script";

/**
 * Contêiner Google Tag Manager do cliente (configurado em "Marketing e Rastreamento").
 *
 * - Só carrega com consentimento de analytics ou advertising.
 * - Antes de carregar, informa o Consent Mode do Google (default negado + update conforme o banner),
 *   para que as tags do contêiner respeitem a escolha do visitante; mudanças posteriores são repassadas.
 * - Publica os eventos do funil no dataLayer (event = job_view | application_start | application_complete),
 *   só com os campos da whitelist, para o cliente usar como gatilho "Evento personalizado".
 */
function dataLayer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
}

// Mesmo formato do gtag(): o GTM interpreta "arguments" de consent no dataLayer
function consentCommand() {
    dataLayer().push(arguments);
}

function consentState(allowed) {
    const analytics = allowed(CONSENT_ANALYTICS) ? "granted" : "denied";
    const advertising = allowed(CONSENT_ADVERTISING) ? "granted" : "denied";

    return {
        analytics_storage: analytics,
        ad_storage: advertising,
        ad_user_data: advertising,
        ad_personalization: advertising,
    };
}

export default {
    name: "gtm",

    isAllowed(config, allowed) {
        return !!(config && config.container_id) && (allowed(CONSENT_ANALYTICS) || allowed(CONSENT_ADVERTISING));
    },

    init(config, allowed) {
        consentCommand("consent", "default", {
            analytics_storage: "denied",
            ad_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
        });
        consentCommand("consent", "update", consentState(allowed));

        dataLayer().push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        injectScript(`https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(config.container_id)}`);
    },

    /**
     * Chamado a cada mudança no banner (inclusive revogação) depois que o contêiner foi carregado.
     */
    consentChanged(config, allowed) {
        const state = consentState(allowed);
        consentCommand("consent", "update", state);
        dataLayer().push({
            event: "selecty_consent_update",
            consent_analytics: state.analytics_storage,
            consent_advertising: state.ad_storage,
        });
    },

    send(eventName, payload) {
        dataLayer().push(Object.assign({ event: eventName }, payload));
    },
};
